import { useEditorActions } from '../../hooks/useEditorActions';
import { useEffect, useContext, useState, useRef } from 'react';
import EditorFilterFamilyOptions from './EditorFilterFamilyOptions';
import EditorTitle from './EditorTitle';
import I18n from 'I18n';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { PopoverCloseButton } from 'foundations-components/transitional/components/Popover';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorGroupedFilterFamilySelectPanelContainer = styled.div.withConfig({
  displayName: "EditorGroupedFilterFamilySelectPanel__EditorGroupedFilterFamilySelectPanelContainer",
  componentId: "sc-1eojqeo-0"
})(["display:flex;flex-direction:column;height:100%;width:400px;"]);
const EditorGroupedFilterFamilySelectPanel = () => {
  const {
    selectedFilterFamilyGroup,
    props: {
      uiMessages: {
        filterCategorySearchInputPlaceholder
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onConditionSelectCancel
  } = useEditorActions();
  const [searchString, setSearchString] = useState('');
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [selectedFilterFamilyGroup]);
  useEffect(() => {
    setSearchString('');
  }, [selectedFilterFamilyGroup]);
  const onSearchChange = evt => {
    setSearchString(evt.target.value);
  };
  return /*#__PURE__*/_jsxs(EditorGroupedFilterFamilySelectPanelContainer, {
    children: [/*#__PURE__*/_jsxs(View, {
      padding: "400",
      as: "div",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(EditorTitle, {}), /*#__PURE__*/_jsx(PopoverCloseButton, {
          onClick: onConditionSelectCancel
        })]
      }), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.filterFamilySelectLabel'),
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(SearchInput, {
          "data-selenium-test": "fr-filter-search-input",
          inputRef: inputRef,
          onChange: onSearchChange,
          placeholder: filterCategorySearchInputPlaceholder || I18n.text('newCustomerDataFilters.fieldSelectFlow.filterFamilySelectPlaceholder'),
          value: searchString
        })
      })]
    }), /*#__PURE__*/_jsx(EditorFilterFamilyOptions, {
      hideIcon: true,
      searchString: searchString
    })]
  });
};
export default EditorGroupedFilterFamilySelectPanel;